import React, { useState } from 'react'
import styles from './style/application_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Foundation from '../../design-system/foundations/Foundation'
import Tabs from '../../design-system/basics/tabs/Tabs'
import Grid from '../../design-system/foundations/grid/Grid'
import Cell from '../../design-system/foundations/grid/Cell'
import Application from '../../design-system/moleculars/application/Application'
import DocumentLink from '../../design-system/moleculars/document-link/DocumentLink'
import Translation from '../../global/Translation'
import { defineMessages } from 'react-intl'

const Applications = (props) => {

    const SENSA = 'Sensa'
    const SCALEA = 'Scalea'
    const LEVELS = {
        'Sensa': [5,5,4,4,4,4,3,3,2],
        'Scalea': [3,5,4,5,5,5,4,5,4]
    }

    const DOC_TEXTS = defineMessages({
        SENSA_DESCRIPTIVE_COLORS: {
            id: 'sensa_descriptive_colors',
            description: 'sensa_descriptive_colors',
            defaultMessage: 'DESCRIPTION OF SENSA COLORS'
        },
        SENSA_INSTALL_GUIDE: {
            id: 'sensa_install_guide',
            description: 'sensa_install_guide',
            defaultMessage: 'SENSA COUNTERTOPS DESIGN AND INSTALLATION GUIDE'
        },
        GRANITE_PETROGRAPHIC_DESC: {
            id: 'granite_petrographic_desc',
            description: 'granite_petrographic_desc',
            defaultMessage: 'GRANITE PETROGRAPHIC DESCRIPTION'
        },
        QUARTZITE_PETROGRAPHIC_DESC: {
            id: 'quartzite_petrographic_desc',
            description: 'quartzite_petrographic_desc',
            defaultMessage: 'QUARTZITE PETROGRAPHIC DESCRIPTION'
        },
        QUESTIONS_AND_ANSWERS: {
            id: 'questions_and_answers',
            description: 'questions_and_answers',
            defaultMessage: 'Questions and_answers',
        },
        PRODUCT_DATA_SHEET: {
            id: 'product_data_sheet',
            description: 'product_data_sheet',
            defaultMessage: 'Product data sheet',
        },
        GRANITES_AND_QUARTZITES: {
            id: 'granites_and_quartzites',
            description: 'granites_and_quartzites',
            defaultMessage: 'Granites and_quartzites',
        }
    })


    const DOCUMENTS = {
        sensaDesc: {
            text1: DOC_TEXTS.SENSA_DESCRIPTIVE_COLORS,
            text2: DOC_TEXTS.QUESTIONS_AND_ANSWERS,
            image: "/assets/natural-stone/sensa_desc_colors.png",
            en: {
                link:"https://assetstools.cosentino.com/api/v1/bynder/doc/C89109B9-56A7-4B72-ACF34A95AEB8136F/sensa-scalea-safety-data-sheet-en.pdf",
                name:"sensa-scalea-safety-data-sheet.pdf"
            },
            es: {
                link:"https://assetstools.cosentino.com/api/v1/bynder/doc/D7005696-1182-4FFB-9B40ACC07E45A798/sensa-scalea-ficha-de-datos-de-seguridad-es.pdf",
                name:"sensa-scalea-ficha-de-datos-de-seguridad-es.pdf"
            }
        },
        installGuide: {
            text1: DOC_TEXTS.SENSA_INSTALL_GUIDE,
            text2: DOC_TEXTS.GRANITES_AND_QUARTZITES,
            image: "/assets/natural-stone/sensa_install_guide.png",
            en: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/0d3371feb46134a78cb70ae1c2c20db9e78ede35",
                name:"[SE] Countertops Design and installation guide (EN).pdf"
            },
            es: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/e84091a82ddc282e02e133fec8402abe820f193c",
                name:"[SE] Countertops Design and installation guide (ES).pdf"
            }
        },
        granitePetrographic: {
            text1: DOC_TEXTS.GRANITE_PETROGRAPHIC_DESC,
            text2: DOC_TEXTS.PRODUCT_DATA_SHEET,
            image: "/assets/natural-stone/granite_petrographic_desc.png",
            en: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/2303c22e28e1a2e7cf62b99828128a8a22d67ec3",
                name:"[CO] Petrographic description. Granite (EN).pdf"
            },
            es: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/886e22c4967f1ed5651832d36d158811b07ea717",
                name:"[CO] Petrographic description. Granite (ES).pdf"
            }
        },
        quartzitePetrographic: {
            text1: DOC_TEXTS.QUARTZITE_PETROGRAPHIC_DESC,
            text2: DOC_TEXTS.PRODUCT_DATA_SHEET,
            image: "/assets/natural-stone/quartzite_petrographic_desc.png",
            en: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/5f907fd25a4360614fb715077ed6386ecc1afb45",
                name:"[CO] Petrographic description. Quartzite (EN).pdf"
            },
            es: {
                link:"https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/1ad030d8428ced93e4f13692f080958459db2e78",
                name:"[CO] Petrographic description. Quarzite (ES).pdf"
            }
        },
    }

    const DOCS_BY_BRAND = {
        Sensa: ['sensaDesc', 'installGuide', 'granitePetrographic', 'quartzitePetrographic'],
        Scalea: ['granitePetrographic', 'quartzitePetrographic'],
    }

    const [selectedBrand, setSelectedBrand] = useState(SENSA)
    const lang = props.lang === 'es' ? 'es' : 'en'
    const currentDocs = DOCS_BY_BRAND[selectedBrand] ? DOCS_BY_BRAND[selectedBrand] : []

    return (
        <div>
            <Typography className={styles['application-title']} typeface="title-xl-light">
                <Translation id="find_ideal_applications" defaultMessage="FIND THE IDEAL APPLICATION"/>
            </Typography>

            <Foundation back-neutral-100>
                <div className={styles['application']}>
                    <Tabs
                        type="selector"
                        selected={0}
                        tabs={[
                            {label: SENSA, onClick: () => setSelectedBrand(SENSA), gtmLabel: "button_sensa-details"},
                            {label: SCALEA, onClick: () => setSelectedBrand(SCALEA), gtmLabel: "button_scalea-details"},
                        ]}
                    />

                    <Typography className={styles['application-label']} typeface="title-m-medium">
                        <Translation id="application_recommended_for_brand"
                                     defaultMessage="Application recommended for {brand}"
                                     values={{brand: selectedBrand}}
                        />
                    </Typography>

                    <Grid className={styles['application-grid']}>
                        <Cell col-4 className={styles['application-column']}>
                            <div>
                                <Application level={LEVELS[selectedBrand][0]} icon="application_top" >
                                    <Translation id="kitchen_island_top"
                                                 defaultMessage="Kitchen Island / top"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][1]} icon="application_furniture" >
                                    <Translation id="furniture"
                                                 defaultMessage="Furniture"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][2]} icon="application_top" >
                                    <Translation id="bath_tops"
                                                 defaultMessage="Bath tops"
                                    />
                                </Application>
                            </div>
                        </Cell>
                        <Cell col-4 className={styles['application-column']}>
                            <div>
                                <Application level={LEVELS[selectedBrand][3]} icon="application_shower" >
                                    <Translation id="shower_plate"
                                                 defaultMessage="Shower plate"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][4]} icon="application_staircase" >
                                    <Translation id="staircase"
                                                 defaultMessage="Staircase"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][5]} icon="application_cladding" >
                                    <Translation id="interior_cladding"
                                                 defaultMessage="Interior cladding"
                                    />
                                </Application>
                            </div>
                        </Cell>
                        <Cell col-4 className={styles['application-column']}>
                            <div>
                                <Application level={LEVELS[selectedBrand][6]} icon="application_cladding" >
                                    <Translation id="exterior_cladding"
                                                 defaultMessage="Exterior cladding"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][7]} icon="application_flooring" >
                                    <Translation id="soleria"
                                                 defaultMessage="Flooring"
                                    />
                                </Application>
                                <Application level={LEVELS[selectedBrand][8]} icon="application_facade" >
                                    <Translation id="facade"
                                                 defaultMessage="Facade"
                                    />
                                </Application>
                            </div>
                        </Cell>

                    </Grid>

                    <div style={{display: currentDocs.length > 0 ? 'block' : 'none'}}>
                        <Typography className={styles['application-label']} typeface="title-m-medium">
                            <Translation id="brand_technical_documentation"
                                         defaultMessage="{brand} technical documentation"
                                         values={{brand: selectedBrand}}
                            />
                        </Typography>
                        <div className={styles['application-documents']}>
                            <div className={styles['application-documents-track']}>
                                {
                                    currentDocs.map(docName => {
                                        const doc = DOCUMENTS[docName]
                                        return (
                                            <DocumentLink brand={selectedBrand.toLowerCase()}
                                                          link={doc[lang].link}
                                                          docName={doc[lang].name}
                                                          image={process.env.PUBLIC_URL + doc.image}
                                                          key={doc.text1.id}
                                                          gtmLabel={`technical-documentation_download-pdf_${doc.text1}`}
                                            >
                                                {props.intl.formatMessage(doc.text1)}
                                                {props.intl.formatMessage(doc.text2)}
                                            </DocumentLink>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Foundation>
        </div>
    )
};


export default Applications;